const tabs = {
  popular: ['rp_763', 'kg_5001'],
  // nuevo: ['rp_687', 'rp_642', 'rp_714', 'rp_711', 'rp_673', 'rp_722', 'rp_719', 'rp_741', 'rp_618', 'rp_664'],
  halloween: [
    'rp_853', // Mad Hit Devil 
    'rp_2', // Medusa Money
  ],
  nuevo: [
    'rp_811',
    'rp_772',
    'kg_5001',
    'rp_804',
    'rp_797',
    'rp_733',
    'rp_730',
    'rp_519',
    'rp_807',
    'rp_801',
    'rp_700',
    'rp_778',
    'rp_755',
    'rp_727',
    'rp_747',
    'rp_744',
    'rp_736',
    'rp_738',
    'rp_788',
    'rp_703',
    'rp_782',
  ],
  xMas: ['rp_595', 'rp_543', 'rp_569'],
};

function getTab(slotName) {
  const trueTab = Object.keys(tabs).reduce(
    (acc, tab) => (tabs[tab].findIndex(item => item === slotName) === -1 ? acc : [...acc, tab]),
    ['slotMachines'],
  );
  return trueTab;
}

export { getTab };
